import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigService } from '../../../services/config/config.service';
import { SeguimientoService } from '../../../services/seguimiento/seguimiento.service';
import { VentaService } from '../../../services/venta/venta.service';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service';
import { HttpErrorResponse } from '@angular/common/http';

/**
 * Componente de seguimiento
 *
 * @export
 * @class SeguimientoComponent
 * @typedef {SeguimientoComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'app-seguimiento',
  templateUrl: './seguimiento.component.html',
  styleUrls: ['./seguimiento.component.scss'],
  standalone: false,
  providers: [MessageService]
})


export class SeguimientoComponent implements OnInit {
  token: any = {};
  infoVentas: Array<any> = [];
  infoVentasFiltered: Array<any> = [];
  infoDetalle: Array<any> = [];
  infoDetalleFiltered: Array<any> = [];
  infoVendedor: Array<any> = ["Todos"];
  selectedSales: string = "Todos";
  detalleVenta: Array<any> = [];
  dateQuery: Date = new Date();
  loadMenu: boolean = true;
  load: boolean = false;
  viewResumen: boolean = false;
  nroVentas: number = 0;
  nroNC: number = 0;
  subtotal: number = 0;
  impuesto: number = 0;
  subtotalNC: number = 0;
  impuestoNC: number = 0;
  infoEmpresa: any = {};
  displayDetail: boolean = false;
  txtBuscador: string = "";
  infoParametrizacion: any = {};
  numTab: number = 0;

  constructor(private seguimiento: SeguimientoService,
    private message: MessageService,
    private venta: VentaService,
    private config: ConfigService,
    private integration: supplierIntegrationService) { }


  /** Inicio de la clase seguimiento */
  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
  }


  /** Obtener la información de las ventas realizadas */
  getInfoVentas = () => {
    this.infoDetalle = [];
    this.infoVendedor = ["Todos"];
    this.selectedSales = "Todos";
    this.txtBuscador = "";
    this.load = true;
    const dateConvert = this.dateQuery.getFullYear() + '-' + (this.dateQuery.getMonth() + 1) + "-" + this.dateQuery.getDate();
    this.seguimiento.getVentasRegistro(this.token.token, dateConvert, dateConvert).subscribe((response) => {
      this.load = false;
      this.infoVentas = response as Array<any>;
      console.table('ventas', this.infoVentas);
      console.table(this.infoVentas);
      this.infoVentasFiltered = this.infoVentas;
      // obtención del detalle
      this.infoVentas.map((row: any) => {
        // revisar si hay que actualizar la información
        /*  if (!!row.integration?.idIntegracion)
           if (row.integration?.idIntegracion != '')
             this.integration.getSaleSiigo(this.token.token, row.integration.idIntegracion).subscribe({
               next: (response1) => { console.log('intgration', response1) },
               error: (error: HttpErrorResponse) => { console.log(error) }
             }) */

        // validar si existe el vendedor
        let arrayVendedor = this.infoVendedor.filter((line: any) => {
          return line.toLowerCase() == (row.vendedor.idEmpleadoNavigation.nombres + ' ' + row.vendedor.idEmpleadoNavigation.apellidos).toLowerCase()
        });
        if (arrayVendedor.length == 0)
          this.infoVendedor.push((row.vendedor.idEmpleadoNavigation.nombres + ' ' + row.vendedor.idEmpleadoNavigation.apellidos).toUpperCase());
        // armado del detalle
        Array.prototype.push.apply(this.infoDetalle, row.detalle.map((field: any) => {
          return {
            venta: field.idVenta,
            codBarras: field.idProductoNavigation.codBarras,
            referencia: field.idProductoNavigation.referencia,
            descripcionCorta: field.idProductoNavigation.descripcionCorta,
            //clase: field.idProductoNavigation.idClaseProductoNavigation.nombreClaseProducto,
            cantidad: field.cantidad,
            subtotal: field.subtotal,
            impuesto: field.impuesto,
            descuento: field.descuento,
            total: field.subtotal + field.impuesto,
            vendedor: row.vendedor.idEmpleadoNavigation.nombres + ' ' + row.vendedor.idEmpleadoNavigation.apellidos,
            cliente: row.cliente?.nombres,
            estado: row.idVentaEstadoNavigation.nombreEstado,
            idEstado: row.idVentaEstadoNavigation.idVentaEstado
          }
        }));
      });
      this.infoDetalleFiltered = this.infoDetalle;
      this.getResumen();

      if (this.infoVentas.length == 0) {
        this.message.add({ severity: 'warn', summary: 'Información', detail: 'No hay información registrada para la fecha consultada' });
      }
    })
  }


  /** Obtener el resumen de las ventas realizadas */
  getResumen = () => {
    this.subtotal = 0;
    this.impuesto = 0;
    this.subtotalNC = 0;
    this.impuestoNC = 0;
    let ventas: Array<any> = [];
    let nc: Array<any> = [];

    switch (this.numTab) {
      case 0:
        // obtención del resumen segun el filtro de información general de ventas
        ventas = this.infoVentasFiltered.filter(row => {
          return row.idVentaEstadoNavigation.idVentaEstado == 3
        });
        nc = this.infoVentasFiltered.filter(row => {
          return row.idVentaEstadoNavigation.idVentaEstado == 4
        });

        ventas.forEach(row => {
          this.subtotal += row.subtotal;
          this.impuesto += row.impuesto;
        });

        nc.map(row => {
          // si la nota credito pertenece al mismo día se deb descontar
          if ((row?.notaCreditoIdVentaNotaNavigations[0].operacion.trim() == '-') && (!row?.notaCreditoIdVentaNotaNavigations[0].activo)) {
            this.subtotal -= row.subtotal;
            this.impuesto -= row.impuesto;
          }
          this.subtotalNC += row.subtotal;
          this.impuestoNC += row.impuesto;
        });
        break;

      case 1:
        // obtención según el detalle de cada venta
        ventas = this.infoDetalleFiltered.filter(row => {
          return row.idEstado == 3
        });
        nc = this.infoDetalleFiltered.filter(row => {
          return row.idEstado == 4
        });

        ventas.forEach(row => {
          this.subtotal += row.subtotal;
          this.impuesto += row.impuesto;
        });

        nc.forEach(row => {
          // si la nota credito pertenece al mismo día se deb descontar
          if ((row?.notaCreditoIdVentaNotaNavigations[0]?.operacion.trim() == '-') && (!row?.notaCreditoIdVentaNotaNavigations[0].activo)) {
            this.subtotal -= row.subtotal;
            this.impuesto -= row.impuesto;
          }
          this.subtotalNC += row.subtotal;
          this.impuestoNC += row.impuesto;
        });
        break;
    }



    this.nroVentas = ventas.length;
    this.nroNC = nc.length;

  }

  filteredDetailSales = () => {
    switch (this.numTab) {
      case 0:
        // información principal de venta
        if (this.selectedSales == "Todos")
          this.infoVentasFiltered = this.infoVentas.filter((item: any) => {
            if (this.txtBuscador != '')
              return (item.idVenta.toString().indexOf(this.txtBuscador) > -1);
            else
              return item;
          });
        else
          this.infoVentasFiltered = this.infoVentas.filter((item: any) => {
            if (this.txtBuscador != '')
              return ((item.vendedor.idEmpleadoNavigation.nombres + ' ' + item.vendedor.idEmpleadoNavigation.apellidos).toLowerCase() == this.selectedSales.toLowerCase()) && (item.idVenta.toString().indexOf(this.txtBuscador) > -1);
            else
              return ((item.vendedor.idEmpleadoNavigation.nombres + ' ' + item.vendedor.idEmpleadoNavigation.apellidos).toLowerCase() == this.selectedSales.toLowerCase());
          })
        break;
      case 1:
        //Detallaado de ventas
        if (this.selectedSales == "Todos")
          this.infoDetalleFiltered = this.infoDetalle.filter((row: any) => {
            if (this.txtBuscador != '')
              return (row.venta.toString().indexOf(this.txtBuscador) > -1 || row.clase.toLowerCase().indexOf(this.txtBuscador.toLowerCase()) > -1 || row.descripcionCorta.toLowerCase().indexOf(this.txtBuscador.toLowerCase()) > -1);
            else
              return row;
          });
        else
          this.infoDetalleFiltered = this.infoDetalle.filter((row: any) => {
            if (this.txtBuscador != '')
              return ((row.vendedor.toLowerCase() == this.selectedSales.toLowerCase()) && (row.venta.toString().indexOf(this.txtBuscador) > -1 || row.clase.toLowerCase().indexOf(this.txtBuscador.toLowerCase()) > -1 || row.descripcionCorta.toLowerCase().indexOf(this.txtBuscador.toLowerCase()) > -1));
            else
              return (row.vendedor.toLowerCase() == this.selectedSales.toLowerCase());
          })
        break;
    }

    this.getResumen();
  }




  openRecibo = (id: number, idComprobante?: number) => {
    window.open(this.config.urlHome + "venta/recibo/" + id + "/" + (!idComprobante ? this.infoParametrizacion.idComprobante : idComprobante));
  }

  openFE = (id: number) => {
    window.open(this.config.urlHome + 'integracion/FE/' + btoa(id.toString()));
  }



  setFacturaElectronicaSIIGO = (item: any, totalPayment?: number) => {
    this.load = true;
    /// getInformationHeader
    this.venta.getHeaderIntegration(this.token.token, item.idVenta).subscribe({
      next: (response: any) => {
        let infoHeader = response as any;
        console.log(infoHeader.valueToRectify);
        let totalGeneral: number = 0;
        this.venta.getDetailHeaderIntegration(this.token.token, item.idVenta).subscribe({
          next: (response1: any) => {

            // add fields 
            let infoDetail = response1 as Array<any>;
            let totalSales = 0;
            console.log(infoDetail);
            infoDetail.map(row => {
              row.code = row.code.toString();
              row.taxes = (row.idTaxesExternSystem ?? '') != '' ?
                (row.idTaxesExternSystem ?? '').split(',').map((item: any) => {
                  return { id: item }
                }) : [];
              row.price = Number(row.price).toFixed(3);
              row.warehouse = !row.warehouse ? null : row.warehouse;
              row.discount = Number(row.discount.toFixed(2));
              totalSales = row.subtotal + row.tax;
              totalGeneral = ((Number(row.price)) * row.quantity) + Number(totalGeneral) + Number(row.tax);
              delete row.idTaxesExternSystem;
              delete row.subtotal;
              delete row.tax;
            });

            this.venta.getDetailPayments(this.token.token, item.idVenta).subscribe({
              next: (response2: any) => {

                let payments: any = response2 as Array<any>;

                // revisar si se tiene impuestos para descontar
                let valorImpuesto = 0;
                if (payments[0].ventaImpuestos.length > 0) {
                  valorImpuesto = payments[0].ventaImpuestos.filter((row: any) => { return row.operation == '-' })
                    .reduce((n: number, row: any) => n + row.valor, 0);
                }



                let paymentsFE = payments[0].ventaPagos.map((row: any) => {
                  return {
                    id: row.idVentaMetodoPagoNavigation?.metodoPagoProveedors[0]?.paymentsIdFe,
                    value: row.valor,
                    // plazo de pago si el metodo de pago lo exije
                    due_date: row.idVentaMetodoPagoNavigation?.metodoPagoProveedors[0]?.registerPaymentTerm ?
                      this.config.formatDateUnique(this.config.addDaysDate(response.date, (payments[0].idClienteNavigation?.carteras[0]?.plazodePago) ?? 1))
                      : this.config.formatDateUnique(response.date),
                  }
                });



                // dicount taxes
                paymentsFE[0].value = (paymentsFE[0].value - valorImpuesto).toFixed(2);

                // pregunta si hay una diferencia de decimales
                if ((infoHeader.valueToRectify ?? 0) == 0) {
                  if ((Number(Number(totalGeneral).toFixed(2)) - valorImpuesto) != paymentsFE[0].value)
                    if (((Number(Number(totalGeneral).toFixed(2)) - valorImpuesto) - paymentsFE[0].value) < 1)
                      paymentsFE[0].value = (Number(Number(totalGeneral).toFixed(2)) - valorImpuesto).toFixed(2);
                } else if (((Number(Number(totalGeneral).toFixed(2)) - valorImpuesto) - Number(infoHeader.valueToRectify)) < 1) {
                  paymentsFE[0].value = Number(infoHeader.valueToRectify);
                }



                //b solo se aceptan máximo dos campos
                let name = response.name.trim().split(' ');
                switch (name.length) {
                  case 3:
                    name.slice(2, 1);
                    break;
                  case 4:
                    name.slice(2, 1);
                    name.slice(name.length - 1, 1)
                    break;
                }
                //dejar en un array
                // razon social: si es compañia debe ser maximo un registro de 100 caracteres
                // otro: el nombre debe quedar en dos partes
                let nameCompany: Array<String> = [];
                if (response.codProveedorDian1 == '31') {
                  nameCompany = response.name.trim().substring(0, 99).split("|")
                } else {
                  // Conocer el numero de pálabras para otros tipos de documento
                  let arrayWords = response.name.trim().split(' ');
                  switch (arrayWords.length) {
                    case 3:
                      nameCompany.push(arrayWords[0] + " " + arrayWords[1]);
                      nameCompany.push(arrayWords[2])
                      break;
                    case 4:
                      nameCompany.push(arrayWords[0] + " " + arrayWords[1]);
                      nameCompany.push(arrayWords[2] + " " + arrayWords[3])
                      break;
                    default:
                      nameCompany.push(arrayWords[0]);
                      nameCompany.push(arrayWords[1]);
                      break;
                  }
                }

                // obteniendo los datos del último año y mes para saber cuando fue creado el cliente
                /* const currentDate = new Date();
                const lastDigitOfYear = currentDate.getFullYear() % 10;
                const currentMonth = currentDate.getMonth() + 1; */
                let ocCustom = {};

                // saber si viene personalizada la orden de compra
                if ((infoHeader.numberOc ?? "") != "") {
                  ocCustom =
                  {
                    "purchase_order": {
                      "prefix": infoHeader.prefijoOc ?? null,
                      "number": infoHeader.numberOc ?? null
                    }
                  }
                }

                const data: any = {
                  "document": {
                    "id": response.documentId
                  },
                  "date": this.config.formatDateUnique(response.date),
                  "customer": {
                    "person_type": response.personType,
                    "id_type": response.codProveedorDian1,
                    "identification": response.identificacion.toString(),
                    //"branch_office": `${lastDigitOfYear}${currentMonth.toString().padStart(2, '0')}`,
                    "branch_office": response.branchOffice,
                    "name": nameCompany,
                    "address": {
                      "address": response.address,
                      "city": {
                        "country_code": response.countryCode,
                        "state_code": response.stateCode,
                        "city_code": response.cityCode
                      },
                      "postal_code": ""
                    },
                    "phones": [
                      {
                        "indicative": response.indicative,
                        "number": response.number,
                        "extension": ""
                      }
                    ],
                    "contacts": [
                      {
                        "first_name": response.nameContact.split(' ')[0],
                        "last_name": response.nameContact.split(' ')[1],
                        "email": response.email,
                        "phone": {
                          "indicative": response.indicative.trim(),
                          "number": response.number.toString(),
                          "extension": ""
                        }
                      }
                    ],
                  },
                  "seller": response.seller,
                  "retentions": (response.idTaxesStr ?? '') != '' ?
                    (response.idTaxesStr ?? '').split(',').map((taxes: any) => {
                      return { id: taxes }
                    }) : [],
                  "stamp": {
                    "send": !(this.infoParametrizacion.checkFe ?? true)
                  },
                  "mail": {
                    "send": !(this.infoParametrizacion.checkFe ?? true)
                  },
                  "observations": response.observations,
                  "items": infoDetail,
                  "payments": paymentsFE,
                  "additional_fields": ocCustom
                }

                console.log('JSON FE', data, 'Proceso de registro');
                // una vez se tiene el JSON es posible enviarlo
                this.integration.setSaleSiigo(this.token.token, data, item.idVenta).subscribe({
                  next: (responseSIIGO: any) => {
                    console.log('responseSIIGO', responseSIIGO);
                    this.load = false;
                    // leer la respúesta para mostrar en pantalla el resultado
                    if (!responseSIIGO?.id)
                      item.integration.message = (responseSIIGO?.Errors[0].Message ?? "")
                    else
                      item.integration.idIntegracion = responseSIIGO?.id ?? "";
                  },
                  error: (error: HttpErrorResponse) => { this.config.handleError(error);this.load = false; }
                })
              },
              error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
            });
          },
          error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }
        });
      },
      error: (error: HttpErrorResponse) => { this.config.handleError(error); this.load = false; }

    });

  }
}
